<template>
  <header
    class="
      pb-8
      sm:pb-14
    "
  >
    <!-- TITLE -->
    <h1
      v-if="data.heading"
      class="
        typo-h-1 mb-5 max-w-[30ch] whitespace-pre-line
        md:mb-10
      "
      v-html="data.heading"
    />

    <!-- TEXT -->
    <div
      v-if="data.text"
      class="
        wysiwyg-only-lists max-w-prose text-lg font-semibold text-gray-500
        md:text-xl
      "
      v-html="data.text"
    />

    <!-- Q3 VIDEO (only for events) -->
    <div
      v-if="data.player_id_3q"
      class="
        my-7 aspect-video w-full
        sm:my-10
      "
    >
      <div ref="Q3Player" />
    </div>

    <!-- IMAGE -->
    <figure
      v-else-if="data.image"
      class="
        my-7
        sm:my-10
      "
    >
      <!-- IMAGE -->
      <AppImage
        :src="data.image"
        class="w-full"
      />

      <figcaption>
        <!-- COPYRIGHT -->
        <Copyright :copyright="data.copyright" />
      </figcaption>
    </figure>

    <!-- LINKS -->
    <div
      v-if="data.links && data.links.length > 0"
      class="mt-6 flex flex-wrap gap-x-3"
    >
      <template v-for="item in data.links">
        <AppButton
          v-if="item.link"
          :key="item.id"
          :to="item.link"
          variant="primary"
        >
          {{ item.link_text }}
        </AppButton>
      </template>
    </div>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object, required: true,
  },
})

const Q3Player = ref<HTMLElement | null>(null)

onMounted(() => {
  if (props.data.player_id_3q) {
    const script = document.createElement('script')
    script.src = '//player.3qsdn.com/js3q.embed.min.js'
    script.setAttribute('data-dataid', props.data.player_id_3q)
    Q3Player.value?.appendChild(script)
  }
})
</script>
